import { RequestrefundreportService } from 'src/services/requestrefundreport.service';
import { showToast } from 'src/utils/common';
import { NOTI_TYPES } from 'src/utils/constants';

import { AppAction } from './app.action';

export const REQUESTREFUNDREPORT_NEW_CARE_SUCCESS = 'REQUESTREFUNDREPORT:NEW_CARE_SUCCESS'
export const REQUESTREFUNDREPORT_LIST_SUCCESS = 'REQUESTREFUNDREPORT:FIND_ALL_SUCCESS'
export const REQUESTREFUNDREPORT_LIST_FAILD = 'REQUESTREFUNDREPORT:FIND_ALL_FAILD'
export const REQUESTREFUNDREPORT_COUNT_ASSIGN_SUCCESS = 'REQUESTREFUNDREPORT:COUNT_ASSIGN_SUCCESS'
export const REQUESTREFUNDREPORT_COUNT_ASSIGN_FAILD = 'REQUESTREFUNDREPORT:COUNT_ASSIGN_FAILD'

export const REQUESTREFUNDREPORT_CREATE_SUCCESS = 'REQUESTREFUNDREPORT:CREATE_SUCCESS'
export const REQUESTREFUNDREPORT_CREATE_FAILD = 'REQUESTREFUNDREPORT:CREATE_FAILD'

export const REQUESTREFUNDREPORT_IMPORT_SUCCESS = 'REQUESTREFUNDREPORT:IMPORT_SUCCESS'
export const REQUESTREFUNDREPORT_SAVE_SUCCESS = 'REQUESTREFUNDREPORT:SAVE_SUCCESS'
export const REQUESTREFUNDREPORT_SAVE_FAILD = 'REQUESTREFUNDREPORT:SAVE_SUCCESS'

export const REQUESTREFUNDREPORT_DEL_SUCCESS = 'REQUESTREFUNDREPORT:DEL_SUCCESS'
export const REQUESTREFUNDREPORT_DEL_FAILD = 'REQUESTREFUNDREPORT:DEL_FAILD'

export const REQUESTREFUNDREPORT_ONE_SUCCESS = 'REQUESTREFUNDREPORT:FIND_ONE_SUCCESS'
export const REQUESTREFUNDREPORT_ONE_FAILD = 'REQUESTREFUNDREPORT:FIND_ONE_FAILD'

export const REQUESTREFUNDREPORT_HISTORY_LIST_SUCCESS = 'REQUESTREFUNDREPORT:HISTORY_FIND_ALL_SUCCESS'
export const REQUESTREFUNDREPORT_HISTORY_LIST_FAILD = 'REQUESTREFUNDREPORT:HISTORY_FIND_ALL_FAILD'

export const REQUESTREFUNDREPORT_UPDATE_FILTER = 'REQUESTREFUNDREPORT:REQUESTREFUNDREPORT_UPDATE_FILTER'

export const RequestrefundreportAction = {
    list,
    findAssign,
    create24hOrder,
    createHoanTienGoiCuoc,
    createNapTienChietKhau,
    importData,
    saveData,
    update,
    del,
    assign,
    countAssign,
    history,
    findOne,
    approve,
    setTransferStatus,
    setTrangThaiGiaoDich,
    updateFilter,
    setTrangThaiTruyThuHoanTheoGoi,
    setTrangThaiTruyThuHoanThem,
    xuatdstruythu,
}

function updateFilter(payload) {
    return { type: REQUESTREFUNDREPORT_UPDATE_FILTER, data: payload }
}

function countAssign() {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        RequestrefundreportService.countAssign().then((rs) => {
            dispatch(success(rs.data.total));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: REQUESTREFUNDREPORT_COUNT_ASSIGN_SUCCESS, data } }
    function failure(error) { return { type: REQUESTREFUNDREPORT_COUNT_ASSIGN_FAILD, error } }
}

function findAssign(page = 0, count = 20) {
    return (dispatch, getState) => {
        const { requestrefundreport } = getState()
        dispatch(AppAction.appLoading(true));
        RequestrefundreportService.findAssign(page, count).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...requestrefundreport.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: REQUESTREFUNDREPORT_LIST_SUCCESS, data } }
    function failure(error) { return { type: REQUESTREFUNDREPORT_LIST_FAILD, error } }
}

function xuatdstruythu() {
    return (dispatch, getState) => {
        const { requestrefundreport } = getState();
        dispatch(AppAction.appLoading(true));

        const { filter } = requestrefundreport;
        const page = filter.page;
        const limit = filter.limit;

        return new Promise((resolve, reject) => {
            RequestrefundreportService.xuatdstruythu(filter.page, filter.limit, filter).then((rs) => {
                resolve(rs);
            }).catch((error) => {
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
}

function list() {
    return (dispatch, getState) => {
        const { requestrefundreport } = getState();
        dispatch(AppAction.appLoading(true));

        const { filter } = requestrefundreport;
        const page = filter.page;
        const limit = filter.limit;

        return new Promise((resolve, reject) => {
            RequestrefundreportService.findAll(filter.page, filter.limit, filter).then((rs) => {
                if (!!filter && filter.page === 0) {
                    dispatch(success({
                        items: rs.data.values,
                        total: rs.data.count,
                        tongHoanTien: rs.data.tongHoanTien,
                        tongHoanThem: rs.data.tongHoanThem,
                        tongNapTien: rs.data.tongNapTien,
                        tongTienSauChietKhau: rs.data.tongTienSauChietKhau,
                    }));
                } else {
                    const oldItems = requestrefundreport.items;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = limit * page; i < limit * page + limit; i++) {
                        if (typeof rsDataValues[i - limit * page] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - limit * page];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        items: uniqueItems,
                        total: rs.data.count,
                        tongHoanTien: rs.data.tongHoanTien,
                        tongHoanThem: rs.data.tongHoanThem,
                        tongNapTien: rs.data.tongNapTien,
                        tongTienSauChietKhau: rs.data.tongTienSauChietKhau,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: REQUESTREFUNDREPORT_LIST_SUCCESS, data } }
    function failure(error) { return { type: REQUESTREFUNDREPORT_LIST_FAILD, error } }
}

function importData(payload) {
    return { type: REQUESTREFUNDREPORT_IMPORT_SUCCESS, data: payload }
}

function saveData(payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        let count = 0
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            RequestrefundreportService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                if (count === payload.length) {
                    dispatch(success(rs));
                    dispatch(RequestrefundreportAction.list())
                    dispatch(AppAction.appLoading(false));
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function success(data) { return { type: REQUESTREFUNDREPORT_SAVE_SUCCESS, data } }
    function failure(error) { return { type: REQUESTREFUNDREPORT_SAVE_FAILD, error } }
}

function create24hOrder(payload) {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            RequestrefundreportService.create24hOrder(payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(RequestrefundreportAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };

    function success(data) { return { type: REQUESTREFUNDREPORT_CREATE_SUCCESS, data } }
    function failure(error) { return { type: REQUESTREFUNDREPORT_CREATE_FAILD, error } }
}

function createHoanTienGoiCuoc(payload, currentOriginUrl = null) {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            RequestrefundreportService.createHoanTienGoiCuoc(payload, currentOriginUrl)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(RequestrefundreportAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };

    function success(data) { return { type: REQUESTREFUNDREPORT_CREATE_SUCCESS, data } }
    function failure(error) { return { type: REQUESTREFUNDREPORT_CREATE_FAILD, error } }
}

function createNapTienChietKhau(payload) {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            RequestrefundreportService.createNapTienChietKhau(payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(RequestrefundreportAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };

    function success(data) { return { type: REQUESTREFUNDREPORT_CREATE_SUCCESS, data } }
    function failure(error) { return { type: REQUESTREFUNDREPORT_CREATE_FAILD, error } }
}

function update(id, payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        RequestrefundreportService.update(id, payload).then((rs) => {
            dispatch(success(rs));
            dispatch(RequestrefundreportAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: REQUESTREFUNDREPORT_CREATE_SUCCESS, data } }
    function failure(error) { return { type: REQUESTREFUNDREPORT_CREATE_FAILD, error } }
}

function approve(id, payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            RequestrefundreportService.approve(id, payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(RequestrefundreportAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: REQUESTREFUNDREPORT_CREATE_SUCCESS, data } }
    function failure(error) { return { type: REQUESTREFUNDREPORT_CREATE_FAILD, error } }
}

function setTrangThaiTruyThuHoanTheoGoi(id, payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            RequestrefundreportService.setTrangThaiTruyThuHoanTheoGoi(id, payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(RequestrefundreportAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: REQUESTREFUNDREPORT_CREATE_SUCCESS, data } }
    function failure(error) { return { type: REQUESTREFUNDREPORT_CREATE_FAILD, error } }
}

function setTrangThaiTruyThuHoanThem(id, payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            RequestrefundreportService.setTrangThaiTruyThuHoanThem(id, payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(RequestrefundreportAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: REQUESTREFUNDREPORT_CREATE_SUCCESS, data } }
    function failure(error) { return { type: REQUESTREFUNDREPORT_CREATE_FAILD, error } }
}

function setTransferStatus(id, payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            RequestrefundreportService.setTransferStatus(id, payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(RequestrefundreportAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: REQUESTREFUNDREPORT_CREATE_SUCCESS, data } }
    function failure(error) { return { type: REQUESTREFUNDREPORT_CREATE_FAILD, error } }
}

function setTrangThaiGiaoDich(id, payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            RequestrefundreportService.setTrangThaiGiaoDich(id, payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(RequestrefundreportAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: REQUESTREFUNDREPORT_CREATE_SUCCESS, data } }
    function failure(error) { return { type: REQUESTREFUNDREPORT_CREATE_FAILD, error } }
}

function del(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        RequestrefundreportService.delete(id).then((rs) => {
            dispatch(success(rs));
            dispatch(RequestrefundreportAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: REQUESTREFUNDREPORT_DEL_SUCCESS, data } }
    function failure(error) { return { type: REQUESTREFUNDREPORT_DEL_FAILD, error } }
}

function findOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        RequestrefundreportService.find(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: REQUESTREFUNDREPORT_ONE_SUCCESS, data } }
    function failure(error) { return { type: REQUESTREFUNDREPORT_ONE_FAILD, error } }
}

function assign(payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        RequestrefundreportService.assign(payload).then((rs) => {
            showToast('success', "Phân chia dữ liệu thành công.")
            dispatch(RequestrefundreportAction.list())
        }).catch((error) => {
            showToast('error', "Phân chia dữ liệu thất bại.\nVui lòng thử lại lần sau.")
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
}


function history(payload) {
    return (dispatch, getState) => {
        const { requestrefundreport } = getState()
        dispatch(AppAction.appLoading(true));
        RequestrefundreportService.history(payload).then((rs) => {
            if (payload.page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...requestrefundreport.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: REQUESTREFUNDREPORT_HISTORY_LIST_SUCCESS, data } }
    function failure(error) { return { type: REQUESTREFUNDREPORT_HISTORY_LIST_FAILD, error } }
}